<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Detalhes do encontro' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>

  <ion-card class="card-full">
    <ion-grid>
      <ion-row>
        <ion-col size="12" class="remove-border">
          <ion-item>
            <ion-label>
              <div class="title-sub">
                <h2 class="name">{{titulo}}</h2>
              </div>

              <div class="title-sub">
                <span class="nome-pessoa">{{mda.pessoa.nome}}</span>
              </div>

              <div class="title-sub">
                <i class="fas fa-calendar-day icon-list"></i>
              </div>

              <div class="title-sub">
                <h3>
                  {{ (mda.dadosMDA.proximoEncontro !== null) ? (mda.dadosMDA.proximoEncontro.data |
                  dateFormat:"dataHora") : '---'}}
                </h3>
              </div>
            </ion-label>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row
        *ngIf="discipulador && mda.dadosMDA.proximoEncontro && !mda.dadosMDA.proximoEncontro.dataConfirmaDiscipulador"
      >
        <ion-col size="10" offset="1">
          <ion-button expand="block" class="btn-success" (click)="confirmar(mda.dadosMDA.proximoEncontro.id)">
            {{'Confirmar Encontro' | translate}}
          </ion-button>
        </ion-col>
      </ion-row>

      <ion-row
        *ngIf="!discipulador && mda.dadosMDA.proximoEncontro && mda.dadosMDA.proximoEncontro.dataConfirmaDiscipulador && !mda.dadosMDA.proximoEncontro.dataConfirmaDiscipulo"
      >
        <ion-col size="10" offset="1">
          <ion-button expand="block" class="btn-success" (click)="confirmar(mda.dadosMDA.proximoEncontro.id)">
            {{'Confirmar Encontro' | translate}}
          </ion-button>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="discipulador && userProvider.hasConfig(99) || !discipulador">
        <ion-col size="10" offset="1">
          <ion-button
            class="yellow btn-edit"
            fill="outline"
            expand="block"
            (click)="desmarcar(mda.dadosMDA.proximoEncontro)"
          >
            {{'Desmarcar encontro' | translate}}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-card class="card-top" *ngIf="mda.dadosMDA.proximoEncontro">
      <ion-card-header class="card-status">
        <ion-card-subtitle>
          <ion-grid>
            <ion-row>
              <ion-col size="12" class="remove-border">
                <ion-item
                  [ngClass]="{'green': mda.dadosMDA.proximoEncontro && mda.dadosMDA.proximoEncontro.dataConfirmaDiscipulo,
                'blue':  mda.dadosMDA.proximoEncontro && !mda.dadosMDA.proximoEncontro.dataConfirmaDiscipulo}"
                >
                  <i
                    class="fas"
                    [ngClass]="mda.dadosMDA.proximoEncontro?.dataConfirmaDiscipulo ? 'fa-check-circle' : 'fa-clock'"
                  ></i>

                  <ion-label>
                    <h3>
                      {{mda.dadosMDA.proximoEncontro && mda.dadosMDA.proximoEncontro.dataConfirmaDiscipulo ?
                      ('Confirmado pelo discipulo ' | translate) : ('Aguardando confirmação do discipulo' | translate)
                      }}
                    </h3>
                  </ion-label>
                </ion-item>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col size="12" class="remove-border">
                <ion-item
                  [ngClass]="{'green': mda.dadosMDA.proximoEncontro && mda.dadosMDA.proximoEncontro.dataConfirmaDiscipulador,
                'blue':  mda.dadosMDA.proximoEncontro && !mda.dadosMDA.proximoEncontro.dataConfirmaDiscipulador}"
                >
                  <i
                    class="fas"
                    [ngClass]="mda.dadosMDA.proximoEncontro?.dataConfirmaDiscipulador ? 'fa-check-circle' : 'fa-clock'"
                  ></i>
                  <ion-label>
                    <h3>
                      {{mda.dadosMDA.proximoEncontro && mda.dadosMDA.proximoEncontro.dataConfirmaDiscipulador ?
                      ('Confirmado pelo discipulador ' | translate) : ('Aguardando confirmação do discipulador' |
                      translate) }}
                    </h3>
                  </ion-label>
                </ion-item>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col size="12" class="remove-border">
                <ion-item>
                  <i class="fas fa-info-circle"></i>
                  <ion-label>
                    <h3 style="color: #7d7d7d">
                      {{ (mda.dadosMDA.proximoEncontro !== null) ? mda.dadosMDA.proximoEncontro.descricao : ''}}
                    </h3>
                  </ion-label>
                </ion-item>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col *ngIf="discipulador" size="4" class="ion-padding-start">
                <ion-button class="btn-branco-edit" expand="block" (click)="remarcar(mda)">
                  {{'Remarcar' | translate}} <i class="fa-solid fa-arrow-rotate-right"></i>
                </ion-button>
              </ion-col>

              <ion-col
                *ngIf="discipulador && mda.dadosMDA.proximoEncontro && mda.dadosMDA.proximoEncontro.dataConfirmaDiscipulador"
                size="4"
                class="ion-padding-start"
              >
                <ion-button expand="block" class="btn-branco-edit" (click)="addHistorico(mda)">
                  {{'Finalizar' | translate}} <i class="fa-solid fa-check"></i>
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-card-subtitle>
      </ion-card-header>
    </ion-card>
  </ion-card>
</ion-content>
